import React from 'react'
import { Link } from 'react-router-dom'

const Logo = () => {
  return (
    <div className='text-[50px] mt-4 ml-[50px] font-heading '>
        <Link className="link" to="/">    Legal Lift</Link>
        
  
    </div>
  )
}

export default Logo

